import {AxiosErrorGeneric, RequestError} from './RequestError'
import axios from 'axios'

export type VariantErrorType = 'error' | 'warning'

function handleErrorWithSnackbar(snackbar: Function, error: unknown, message: string, variant?: VariantErrorType) {
  const err = error as AxiosErrorGeneric
  const isNetworkError = axios.isAxiosError(err) && !err?.response && (err.code === 'ERR_NETWORK' || err.message === 'Network Error')

  if (isNetworkError) {
    console.error("Network error! Can't establish connection with network!")
    snackbar('Sem conexão com a internet. Verifique sua conexão de rede.', {
      variant: 'warning',
    })
    return
  }

  if (err?.response?.data?.devMessage?.includes('A câmera está offline'))
    snackbar('Não é possível cadastrar uma detecção enquanto a câmera estiver offline. Altere o status para "Habilitada" antes de continuar', {
      variant: 'error',
    })
  if (err?.response) {
    snackbar(`${message}: ${RequestError(err)}`, {
      variant: variant ?? 'error',
    })
  } else {
    snackbar(message, {variant: 'error'})
    console.error(error)
  }
}

export default handleErrorWithSnackbar
